import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { TFunction, i18n } from 'i18next';
import { ITheme, IStyle } from 'office-ui-fabric-react/lib/Styling';
import { IStyleFunctionOrObject, classNamesFunction, memoizeFunction } from '@uifabric/utilities/lib/';
import { globalContext } from '../helpers/GlobalContexts';
import { getTheme } from '@uifabric/styling/lib/styles';

const getClassNames = classNamesFunction<StyleProps, Styles>();

/**
 * This interface defines the state of the side panel component.
 */
interface State {
    loading: boolean,
    showEngPanel: boolean,
    showServerAccessError: boolean
}

/**
 * This interface defines the props of the side panel component.
 */
interface Props {
    t: TFunction,
    tReady: boolean,
    i18n: i18n,
    theme?: ITheme,
    styles?: IStyleFunctionOrObject<StyleProps, Styles>;
}

interface StyleProps {
    theme?: ITheme;
}

interface Styles {
    content: IStyle;
}

export interface SidePanelStyles {
    content: IStyle;
}

const getStyles = memoizeFunction(
    (theme: ITheme): Partial<SidePanelStyles> => {
        return {
            content: [
                {
                    borderColor: theme.palette.neutralSecondary,
                    backgroundColor: theme.palette.white
                }
            ]
        };
    });

/**
 * This component is the top-level component of the side panel.
 */

class SidePanelComponent extends Component<Props, State> {
    static contextType = globalContext;
    declare context: React.ContextType<typeof globalContext>;
    protected dialog: Office.Dialog;
    protected dialogUuid: string;
    protected infobox: string = null;

    /**
     * This is the state object of the component. 
     * Never change the values directly, always use the setState() API.
     */
    public state: State = {
        loading: false,
        showEngPanel: false,
        showServerAccessError: false
    };

    constructor(props: Props) {
        super(props);
    }

    /**
     * This function is called every time the component is rendered.
     */
    public render() {
        const { t } = this.props;
        const theme = getTheme();
        const classNames = getClassNames(getStyles(theme!));
        let infoClassNames = "infobox " + ((theme.palette.black == '#f8f8f8') ? 'dark' : '');
        let infobox = t("panel.info_text");
        let infoBoxElelemnt: JSX.Element = 
                    <div className={infoClassNames} dangerouslySetInnerHTML={{ __html: infobox }} style={{ color: theme.palette.black, fontSize: '17px' }}>
            </div>;
        return (
            <div id="side_panel_content" className={classNames.content + " ms-Grid"} dir="ltr">
                <div className="ms-Grid-row row-lg">
                    <div className="ms-Grid-col ms-fontSize-xxl ms-sm10" style={{ color: theme.palette.themePrimary }}>
                        {t('panel.heading')}
                    </div>
                </div>
                <div className="infobox_img_container">
                {infoBoxElelemnt}
                {/* <div className="side_panel_link">
                    <a href="www.waitingForTheLink.com">Link to SharePoint site</a>

                </div> */}
                <img
                    className="panel_secure_image"
                    src={t("panel.info_icon_url")}
                    alt="Panel secure image"
                />
                </div>
                
            </div>
        );
    }
}
export default withTranslation()(SidePanelComponent);